import { USERS_GET } from '../actions';

export const loadAllUsers = () => ({
  type: USERS_GET,
});
